require('./helpers/bundle-manifest').register(JSON.parse("{\"EVgbq\":\"index.f2766491.js\",\"bDvwL\":\"feather-sprite.2b6a67b5.svg\"}"));